import activeInvestmentsSagas from './activeInvestments/sagas';
import browsePageSagas from './browsePage/sagas';

export default [
  ...activeInvestmentsSagas,
  ...browsePageSagas,
];
